import { PenIcon } from 'lucide-react';
import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';

export function EditButton(props: ComponentProps<typeof Button>) {
  return (
    <Button
      className="text-dark-blue-primary-smc-500 hover:text-dark-blue-primary-smc-500"
      variant="ghost"
      {...props}
    >
      <PenIcon />
      Edit
    </Button>
  );
}
